import { render } from "./PhoneRecordings.vue?vue&type=template&id=5171f5b2&scoped=true"
import script from "./PhoneRecordings.vue?vue&type=script&lang=js"
export * from "./PhoneRecordings.vue?vue&type=script&lang=js"

import "./PhoneRecordings.vue?vue&type=style&index=0&id=5171f5b2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5171f5b2"]])

export default __exports__